<div class="relative pt-[17px] mt-[24px] {{ hideOnMobile ? 'hidden md:block' : '' }}">
  <div class="bg-ace-mode-linear absolute top-0 left-6 z-10 inline-flex items-center gap-[0.5rem] mb-[.75rem] text-dark h-[30px] px-[20px] rounded-[30px]">
    <svg style="width:11px;" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 11 15" xml:space="preserve" fill="#21333F">
      <path d="M5.1,0h5.4L7,5.2h4L1,15l3.2-7.2L0,7.8L5.1,0z"></path>
    </svg>
    <span class="text-dark !text-sm font-black tracking-wider uppercase !leading-none">{{ badgeText }}</span>
  </div>
  <a [href]="linkUrl ?? '#'" class="group flex w-full items-center space-between gap-4 pt-0.5 pl-0.5 pr-1.5 pb-2 rounded-3xl relative bg-ace-mode-linear !no-underline">
    <div class="bg-vis-white flex w-full gap-4 rounded-3xl pt-[22px] pb-[16px] px-[22px]">
      <div class="flex gap-0.5 flex-col">
        @if (headline) {
          <h3 class="mb-0 text-md font-extrabold text-dark leading-[1.4]">{{ headline }}</h3>
        }
        @if (description) {
          <p class="!text-baselg text-vis-subtle font-regular !leading-[1.5]">{{ description }}</p>
        }
      </div>
      <div
        class="bg-ace-mode-linear-animated bg-[length:200%_100%] flex items-center justify-center size-12 shrink-0 rounded-full group-hover:animate-[gradient-shift_300ms_ease-in-out_1] text-dark"
        [attr.aria-label]="linkText || 'Learn more about Ace Mode'"
      >
        <svg
          class="h-6 w-6"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          [style.transform]="arrowRotation"
          style="transition: transform 200ms ease-in-out"
        >
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </div>
    </div>

  </a>
</div>
